import React, { lazy } from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-darker py-12 px-4 border-t border-white/5" data-id="element-61">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-62">
        {/* Logo */}
        <a href="#inicio" className="flex-shrink-0" data-id="element-63">
          <img src="https://cdn.magicpatterns.com/uploads/7iH6zyTr3rcaNUzsDXXd7i/Exclusive_agent_leads_logo_(1000_x_500_px)_2.png" alt="Xclusive Agent Leads Logo" className="h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity" loading="lazy" decoding="async" data-id="element-64" />
        </a>

        {/* Phone & Copyright */}
        <div className="flex flex-col items-center md:items-end gap-2" data-id="element-65">
          <p className="text-gray-500 text-sm" data-id="element-66">
            &copy; {currentYear} Xclusive Agent Leads. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}